(function () {
  /* Üres kosár CRO: ingyenes szállítás sáv + social proof + visszaszámláló + legújabb darabok */
  var hu = (document.documentElement.lang || '').toLowerCase().indexOf('hu') === 0;
  var tpl = null, items = null, loading = false;
  function load() {
    if (loading || tpl !== null) return;
    loading = true;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'collections/all?sort_by=created-descending&section_id=candy-empty-new', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var t = tmp.querySelector('[data-candy-empty-tpl]'), it = tmp.querySelector('[data-candy-new-items]');
        tpl = t ? t.innerHTML.trim() : '';
        items = it ? it.innerHTML.trim() : '';
        run();
      })
      .catch(function () { tpl = ''; items = ''; });
  }
  function money(el) {
    el.setAttribute('data-candy-done', '1');
    var cur = window.Shopify && Shopify.currency;
    if (!cur || !cur.active || cur.active === 'HUF') return;
    var v = +el.getAttribute('data-candy-limit') / 100 * (parseFloat(cur.rate) || 1);
    try { el.textContent = new Intl.NumberFormat(hu ? 'hu-HU' : 'en-US', { style: 'currency', currency: cur.active, maximumFractionDigits: 0 }).format(Math.ceil(v)); } catch (e) {}
  }
  function fillGrid(g) {
    if (!g || !items || g.querySelector('.candy-empty__card')) return;
    g.innerHTML = items;
    var n = g.closest('[data-candy-new]'); if (n) n.hidden = false;
  }
  function run() {
    var holders = document.querySelectorAll('.cart-drawer__empty-message:not(.cart-drawer__empty-message--bottom)');
    if (!holders.length) return;
    document.querySelectorAll('.cart-drawer__empty-message--bottom a[href]').forEach(function (a) {
      var h = a.getAttribute('href');
      if (/\/collections\/all\/?$/.test(h)) a.setAttribute('href', h + '?sort_by=created-descending');
      if (!a.querySelector('.candy-cta-txt') && a.closest('.cart-empty-buttons')) {
        var hb = a.querySelector('hover-button');
        a.textContent = '';
        if (hb) a.appendChild(hb);
        var ct = document.createElement('span');
        ct.className = 'candy-cta-txt';
        ct.textContent = hu ? 'Vásárolj a legújabb ruhák közül →' : 'Shop the newest drops →';
        a.appendChild(ct);
      }
    });
    document.querySelectorAll('[data-candy-limit]:not([data-candy-done])').forEach(money);
    if (tpl === null) { load(); }
    holders.forEach(function (box) {
      var el = box.querySelector('.candy-empty');
      if (!el) {
        /* tartalék: ha a szerver még a régi sablont adta */
        if (!tpl) return;
        var tmp = document.createElement('div'); tmp.innerHTML = tpl;
        el = tmp.firstElementChild; if (!el) return;
        var h = box.querySelector('h3'), after = h || box.querySelector('p');
        if (after && after.parentNode === box) box.insertBefore(el, after.nextSibling); else box.appendChild(el);
      }
      fillGrid(el.querySelector('[data-candy-new-grid]'));
    });
  }
  /* Termékállapot:
     - "Állapot: 10/10 - Jó", "Állapot: 9/10" → 8/10 vagy afölött: "Állapot: 10/10 – Kiváló!" (EN: Excellent!)
     - HU: szöveges állapot mindig "Kiváló!" (Good / Jó / Very good / Sehr gut → Kiváló!) */
  var COND = /((?:Állapot|Condition|Zustand)\s*:\s*)(very good|sehr gut|excellent|nagyon jó|kiváló|good|gut|jó)(?![A-Za-zÁÉÍÓÖŐÚÜŰáéíóöőúüű])!?/i;
  var COND_SCORE = /((?:Állapot|Condition|Zustand)\s*:\s*)(\d{1,2}(?:[.,]\d)?)\s*\/\s*10(?:\s*[-–—:]?\s*(?:very good|sehr gut|excellent|nagyon jó|kiváló|good|gut|jó|jo|ok|fair|használt)(?![A-Za-zÁÉÍÓÖŐÚÜŰáéíóöőúüű])!?)?/i;
  function fixCond() {
    document.querySelectorAll('[class*="product-tabs-answer-"], .product__description, .product-single .rte, product-sticky .rte').forEach(function (box) {
      var w = document.createTreeWalker(box, NodeFilter.SHOW_TEXT), n;
      while ((n = w.nextNode())) {
        var v = n.nodeValue, nv = v, m = COND_SCORE.exec(v);
        if (m) {
          var score = parseFloat(m[2].replace(',', '.'));
          if (score >= 8 && score <= 10) nv = v.replace(COND_SCORE, '$1$2/10 – ' + (hu ? 'Kiváló!' : 'Excellent!'));
        } else if (hu && COND.test(v)) {
          nv = v.replace(COND, '$1Kiváló!');
        }
        if (nv !== v) n.nodeValue = nv;
      }
    });
  }
  /* ---------- Teli kosár: trust stack a Pénztár gomb fölött ---------- */
  var IC = {
    shield: '<svg width="14" height="14" viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M12 1 3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"/></svg>',
    ret: '<svg width="14" height="14" viewBox="0 0 24 24" aria-hidden="true"><path fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" d="M3 12a9 9 0 1 0 3-6.7M3 4v5h5"/></svg>',
    cash: '<svg width="14" height="14" viewBox="0 0 24 24" aria-hidden="true"><rect x="2" y="6" width="20" height="12" rx="2" fill="none" stroke="currentColor" stroke-width="2"/><circle cx="12" cy="12" r="2.6" fill="none" stroke="currentColor" stroke-width="2"/></svg>',
    star: '<svg width="14" height="14" viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="m12 2 3.1 6.3 6.9 1-5 4.9 1.2 6.8L12 17.8 5.8 21l1.2-6.8-5-4.9 6.9-1z"/></svg>',
    lock: '<svg width="14" height="14" viewBox="0 0 24 24" aria-hidden="true"><rect x="4" y="10" width="16" height="11" rx="2" fill="none" stroke="currentColor" stroke-width="2"/><path d="M8 10V7a4 4 0 0 1 8 0v3" fill="none" stroke="currentColor" stroke-width="2"/></svg>'
  };
  function sp(i, t) { return '<span>' + IC[i] + t + '</span>'; }
  function trustHtml() {
    return hu
      ? '<div class="candy-checkout-trust__row">' + sp('shield', '100% eredeti') + sp('ret', '14 napos visszaküldés') + sp('cash', 'Utánvét') + '</div>' +
        '<div class="candy-checkout-trust__row candy-checkout-trust__row--sub">' + sp('star', '1500+ elégedett vásárló') + sp('lock', 'Biztonságos rendelés') + '</div>'
      : '<div class="candy-checkout-trust__row">' + sp('shield', '100% authentic') + sp('ret', '14-day returns') + '</div>' +
        '<div class="candy-checkout-trust__row candy-checkout-trust__row--sub">' + sp('star', '1500+ happy customers') + sp('lock', 'Secure checkout') + '</div>';
  }
  function fixTrust() {
    document.querySelectorAll('.cart__foot-inner').forEach(function (f) {
      if (f.querySelector('.candy-checkout-trust')) return;
      var w = f.querySelector('.cart__buttons-wrapper');
      if (!w) return;
      var d = document.createElement('div');
      d.className = 'candy-checkout-trust';
      d.innerHTML = trustHtml();
      w.parentNode.insertBefore(d, w);
    });
  }

  /* ---------- Rövidebb kiszállítási szöveg: "Rendeld meg X-en belül → várható érkezés: szept. 29–30." ---------- */
  var HM = ['jan.', 'febr.', 'márc.', 'ápr.', 'máj.', 'jún.', 'júl.', 'aug.', 'szept.', 'okt.', 'nov.', 'dec.'];
  var EM = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  function etaCd(ms) {
    var d = Math.floor(ms / 864e5), h = Math.floor(ms % 864e5 / 36e5), m = Math.floor(ms % 36e5 / 6e4);
    if (hu) return d > 0 ? d + ' nap ' + h + ' órán' : (h > 0 ? h + ' óra ' + m + ' percen' : m + ' percen');
    return d > 0 ? d + 'd ' + h + 'h' : (h > 0 ? h + 'h ' + m + 'm' : m + 'm');
  }
  function etaRange(a, b) {
    var M = hu ? HM : EM;
    if (a.getMonth() === b.getMonth()) return hu ? M[a.getMonth()] + ' ' + a.getDate() + '–' + b.getDate() + '.' : M[a.getMonth()] + ' ' + a.getDate() + '–' + b.getDate();
    return hu ? M[a.getMonth()] + ' ' + a.getDate() + '. – ' + M[b.getMonth()] + ' ' + b.getDate() + '.' : M[a.getMonth()] + ' ' + a.getDate() + ' – ' + M[b.getMonth()] + ' ' + b.getDate();
  }
  function etaRender() {
    if (!this.textEl || !window.candyShipping) return;
    var c = window.candyShipping(), cd = etaCd(c.left), r = etaRange(c.from, c.to);
    this.textEl.innerHTML = hu
      ? 'Rendeld meg <strong class="candy-green">' + cd + '</strong> belül → várható érkezés: <strong>' + r + '</strong>'
      : 'Order within <strong class="candy-green">' + cd + '</strong> → arrives <strong>' + r + '</strong>';
  }
  function patchEta() {
    var C = window.customElements && customElements.get('candy-delivery-eta');
    if (!C) return;
    if (!C.prototype.__candy) { C.prototype.__candy = true; C.prototype.render = etaRender; }
    document.querySelectorAll('candy-delivery-eta').forEach(function (e) {
      if (e.__candy) return;
      e.__candy = true;
      if (!e.textEl) e.textEl = e.querySelector('[data-eta-text]');
      clearInterval(e.timer);
      e.timer = setInterval(etaRender.bind(e), 30000);
      etaRender.call(e);
    });
  }

  /* ---------- Pogány profilkép csere (Section Store social proof) ---------- */
  var AV_OLD = '607365e3e3926961b0fba66907d52238', AV_NEW = 'https://cdn.shopify.com/s/files/1/0904/1087/7194/files/candy-av-pogany-v2.jpg?v=1790439072';
  function swapAv() {
    document.querySelectorAll('img[src*="' + AV_OLD + '"]').forEach(function (i) {
      i.removeAttribute('srcset'); i.removeAttribute('sizes'); i.src = AV_NEW;
    });
  }

  /* ---------- Termékoldali upsell ("Ez is érdekelhet"): csak ajánlott termékek + gyors kosárba ---------- */
  var REL_T = hu
    ? { sub: 'Ezek hozzád illenek 🔥', auth: '✓ 100% eredeti', add: '+ Kosárba', added: '✓ Kosárban', sold: 'Elfogyott' }
    : { sub: 'These match your style 🔥', auth: '✓ 100% authentic', add: '+ Add to cart', added: '✓ Added', sold: 'Sold out' };
  function fixRelated() {
    document.querySelectorAll('related-products').forEach(function (sec) {
      var added = false;
      var links = sec.querySelectorAll('.tabs__link');
      if (links.length > 1) {
        for (var i = 1; i < links.length; i++) links[i].remove();
        sec.querySelectorAll('.tab[data-tab]').forEach(function (t) { if (t.getAttribute('data-tab') !== '0') t.remove(); });
      }
      var head = sec.querySelector('.tabs__head') || sec.querySelector('.section__header');
      if (head && !sec.querySelector('.candy-rel-sub')) {
        var p = document.createElement('p'); p.className = 'candy-rel-sub'; p.textContent = REL_T.sub;
        head.parentNode.insertBefore(p, head.nextSibling);
      }
      sec.querySelectorAll('.product-grid-item').forEach(function (it) {
        var info = it.querySelector('.product-grid-item__info');
        if (!info || info.querySelector('.candy-rel-add')) return;
        var a = info.querySelector('a[href*="/products/"]');
        if (!a) return;
        var m = a.getAttribute('href').match(/\/products\/([^?#\/]+)/);
        if (!m) return;
        var au = document.createElement('span'); au.className = 'candy-rel-auth'; au.textContent = REL_T.auth;
        info.appendChild(au);
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'candy-rel-add'; b.setAttribute('data-candy-rel', m[1]); b.textContent = REL_T.add;
        info.appendChild(b);
        added = true;
      });
      if (added) relResize(sec);
    });
  }
  function relResize(sec) {
    [60, 600, 1500].forEach(function (t) {
      setTimeout(function () {
        try {
          var sl = sec.querySelector('.flickity-enabled');
          var f = sl && window.theme && theme.Flickity && theme.Flickity.data(sl);
          if (f) f.resize();
        } catch (e) {}
      }, t);
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-candy-rel]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    if (b.classList.contains('is-loading') || b.classList.contains('is-added')) return;
    b.classList.add('is-loading');
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'products/' + b.getAttribute('data-candy-rel') + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var v = (p.variants || []).filter(function (x) { return x.available; })[0];
        if (!v) { b.textContent = REL_T.sold; b.classList.remove('is-loading'); b.disabled = true; throw 0; }
        return fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] }) });
      })
      .then(function (r) { if (!r.ok) throw r; return fetch(root + 'cart.js').then(function (c) { return c.json(); }); })
      .then(function (cart) {
        b.classList.remove('is-loading'); b.classList.add('is-added'); b.textContent = REL_T.added;
        document.querySelectorAll('[data-cart-count]').forEach(function (el) { if (/^\s*\(?\d*\)?\s*$/.test(el.textContent)) el.textContent = cart.item_count; });
        document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
        setTimeout(function () { document.dispatchEvent(new CustomEvent('theme:cart:open', { bubbles: true })); }, 350);
      })
      .catch(function (err) {
        if (err === 0) return;
        b.classList.remove('is-loading'); b.classList.add('is-error');
        setTimeout(function () { b.classList.remove('is-error'); }, 1500);
      });
  }, true);

  /* ---------- Vásárlói fal CTA → legújabb készlet ---------- */
  function fixCspCta() {
    document.querySelectorAll('a.csp__cta[href]').forEach(function (a) {
      var h = a.getAttribute('href');
      if (/\/collections\/all\/?$/.test(h)) a.setAttribute('href', h.replace(/\/$/, '') + '?sort_by=created-descending');
    });
  }

  /* ---------- Social proof 2. profilkép ---------- */
  var AV2_OLD = '/files/images_5.jpg';
  var AV2_NEW = (function () { var s = document.currentScript && document.currentScript.src; return s ? s.replace(/candy-empty-cart\.js.*$/, 'candy-av-2.webp') : ''; })();
  function swapAv2() {
    if (!AV2_NEW) return;
    document.querySelectorAll('img[src*="' + AV2_OLD + '"]').forEach(function (i) {
      i.removeAttribute('srcset'); i.removeAttribute('sizes'); i.src = AV2_NEW;
    });
  }

  var q = null;
  function safe() { try { run(); } catch (e) {} try { fixCond(); } catch (e) {} try { fixTrust(); } catch (e) {} try { patchEta(); } catch (e) {} try { swapAv(); } catch (e) {} try { fixRelated(); } catch (e) {} try { fixCspCta(); } catch (e) {} try { swapAv2(); } catch (e) {} }
  new MutationObserver(function () { if (q) return; q = setTimeout(function () { q = null; safe(); }, 20); }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', safe); else safe();
  (window.requestIdleCallback || setTimeout)(load);
})();
